module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/~/json-loader!./.cache/json/components-popover.json
// module id = 985
// module chunks = 144966194352666